import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IClientIP } from './i-getclientip';

@Injectable({
  providedIn: 'root'
})
export class GetclientipdetailsService {

  constructor( private _httpClient: HttpClient ) { }

  //private ipURL: string = 'http://ip-api.com/json';
  private ipURL: string = 'https://ipapi.co/json';

  getIPDetails(): Observable<IClientIP> {
    return this._httpClient.get<IClientIP>(this.ipURL);
  }
}
